import React, { useEffect, useState } from "react";
import { useTables } from "../../../../../../../context/OrderCreator/TablesContext";
import OrderInfoCard from "./OrderInfoCard";
import OrderItemsList from "./OrderItemsList";
import EditOrderForm from "../OrderActions/EditOrderForm";
import EditItemModal from "../ItemsActions/EditItemModal";
import MoveItemModal from "../ItemsActions/MoveItemModal";
import { Button, IconButton, Menu, MenuItem } from "@mui/material";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import KitchenIcon from "@mui/icons-material/Kitchen";
import { useOrder } from "../../../../../../../context/OrderCreator/TablesContext/OrderContext";
import { usePermissions } from "../../../../../../../context/PermissionsAndFeatures/UserPermissionsContext";
import { useFeatures } from "../../../../../../../context/PermissionsAndFeatures/FeaturesContext";
import { useSettings } from "../../../../../../../context/SettingsContext"; // NEW: read settings
import { changeOrderItemStatus as changeOrderItemStatusApi } from "../../../../../../../services/Settings/Orderprocessing"; // ADD: import API service to change item status
import { handleBrowserPrint } from "../../../../../../../components/PagesComponents/PosSection/PrintTemplates/Taghez/printUtilsTaghez"; // ✅ استيراد دالة الطباعة
import {
  makeItemsInPreparation,
  printItems,
} from "../../../../../../../services/Settings/printers"; // NEW: استيراد دالة وضع العناصر قيد التجهيز و دالة الطباعة للباك اند

const OrderDetailsFetcher = ({
  orderId,
  onReload,
  onClose,
  onOrderDeleted,
}) => {
  const {
    orderDetails,
    loadOrder,
    deleteItem,
    updateItem,
    moveItem,
    removeOffer,
    deleteOrder, // ✅ إضافة deleteOrder
    loading,
    error,
  } = useOrder();

  // NEW: read settings to check preparation_casher_button
  const { settings = {}, loading: settingsLoading } = useSettings() || {};
  const preparationCasherEnabled =
    settings?.preparation_casher_button === 0 ||
    settings?.preparation_casher_button === "0";

  const [editOpen, setEditOpen] = useState(false);
  const [editData, setEditData] = useState(null);
  const [successMsg, setSuccessMsg] = useState("");
  const [itemEditOpen, setItemEditOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [moveModalOpen, setMoveModalOpen] = useState(false);
  const [selectedMoveItem, setSelectedMoveItem] = useState(null);
  const [kitchenMenuAnchor, setKitchenMenuAnchor] = useState(null);
  const [sentItems, setSentItems] = useState([]);
  const {
    tables,
    loading: tablesLoading,
    error: tablesError,
    refresh: refreshTables,
  } = useTables();
  const { hasPermission } = usePermissions();
  // feature flag for printing control
  const { hasFeature, featuresLoading } = useFeatures();
  const printingEnabled = !featuresLoading && hasFeature("printing_control");

  // ✅ تحميل تفاصيل الأوردر من الـ Context
  useEffect(() => {
    if (orderId) loadOrder(orderId);
  }, [orderId, loadOrder]);

  // ✅ تحديث عند الطلب من parent
  useEffect(() => {
    if (onReload) onReload(() => loadOrder(orderId));
  }, [onReload, orderId, loadOrder]);

  // ✅ useEffect لإضافة اختصار F9 لطباعة التجهيز
  useEffect(() => {
    const handleKeyDown = (e) => {
      // التحقق من F9 (keyCode 120)
      if (e.key === "F9" || e.keyCode === 120) {
        e.preventDefault(); // منع السلوك الافتراضي
        if (
          hasPermission("orders_tables_print_preparation_table") &&
          printingEnabled &&
          pendingItems.length > 0
        ) {
          handlePrintPreparation();
        }
      }
    };

    // إضافة المستمع
    window.addEventListener("keydown", handleKeyDown);

    // تنظيف المستمع عند unmount
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [hasPermission, printingEnabled, orderDetails, settings]);

  const handleDeleteItem = async (itemId) => {
    if (!orderDetails) return alert("❌ لا توجد تفاصيل للطلب حالياً.");

    // إيجاد العنصر في تفاصيل الأوردر باستخدام المعرف (للتوافق مع OrderItemsList الحالي)
    const item = orderDetails.items?.find(
      (i) => String(i.id) === String(itemId),
    );
    if (!item) return alert("❌ لم يتم العثور على الصنف للحذف.");

    if (!window.confirm("❗ هل تريد حذف هذا الصنف من الطلب؟")) return;

    try {
      if (item.is_offer === 1) {
        // إذا كان العنصر عرضاً استعمل removeOffer من الـ Context
        await removeOffer({ order_id: orderDetails.id, offer_id: item.id });
        setSuccessMsg("✅ تم حذف العرض من الطلب بنجاح");
      } else {
        // صنف عادي: حذف عبر deleteItem
        await deleteItem(item.id);
        setSuccessMsg("✅ تم حذف الصنف بنجاح");
      }

      // 🔔 إشعار للـ TablesSection
      window.dispatchEvent(
        new CustomEvent("orderUpdated", {
          detail: { orderId, tableId: orderDetails.table_id },
        }),
      );
    } catch (err) {
      alert(err.message || "❌ فشل في حذف الصنف / العرض");
    }
  };

  const handleUpdateItem = async (updatedData) => {
    try {
      await updateItem(updatedData);
      setSuccessMsg("✅ تم تعديل بيانات الصنف بنجاح");
      setItemEditOpen(false);

      // 🔔 إشعار
      window.dispatchEvent(
        new CustomEvent("orderUpdated", {
          detail: { orderId, tableId: orderDetails.table_id },
        }),
      );
    } catch (err) {
      alert(err.message || "❌ فشل في تعديل الصنف");
    }
  };

  const handleMoveItem = async (data) => {
    try {
      await moveItem(orderId, data);
      setSuccessMsg("✅ تم نقل الصنف بنجاح");
      setMoveModalOpen(false);

      // 🔔 إشعار
      window.dispatchEvent(
        new CustomEvent("orderUpdated", {
          detail: { orderId, tableId: orderDetails.table_id },
        }),
      );

      // الكود القديم بتاع تحديث الطاولة المستهدفة:
      if (typeof window.updateTableData === "function") {
        window.updateTableData(parseInt(data.target_table));
      }
    } catch (err) {
      alert(err.message || "❌ فشل في نقل الصنف");
    }
  };

  // NEW: prepare item handler — يغير حالة العنصر إلى "preparing" (يمكن تعديل الحالة المطلوبة حسب API)
  const handlePrepareItem = async (item) => {
    if (!item) return;
    if (
      !window.confirm(
        `هل تريد وضع الصنف "${item.product_name || item.name || item.id}" في حالة التجهيز؟`,
      )
    )
      return;
    try {
      // نفترض أن updateItem يتلقى كائن يحتوي على id وحقول للتعديل
      await updateItem({ id: item.id, status: "preparing" });
      setSuccessMsg("✅ تم وضع الصنف قيد التجهيز");
      // إشعار للأجزاء الأخرى بالتحديث
      window.dispatchEvent(
        new CustomEvent("orderUpdated", {
          detail: { orderId, tableId: orderDetails.table_id },
        }),
      );
    } catch (err) {
      alert(err.message || "❌ فشل في وضع الصنف قيد التجهيز");
    }
  };

  // NEW: changeOrderItemStatus(id) — يستعمله OrderItemsList لإرسال المعرف فقط
  const changeOrderItemStatus = async (itemId) => {
    if (!itemId) return;
    if (!orderDetails) return alert("❌ لا توجد تفاصيل للطلب حالياً.");
    const item = orderDetails.items?.find(
      (i) => String(i.id) === String(itemId),
    );
    if (!item) return alert("❌ لم يتم العثور على الصنف.");
    if (
      !window.confirm(
        `هل تريد وضع الصنف "${item.product_name || item.name || item.id}" قيد التجهيز؟`,
      )
    )
      return;

    try {
      // حاول استدعاء دالة الـ API أولاً، إن لم تكن موجودة استخدم updateItem كـ fallback
      if (typeof changeOrderItemStatusApi === "function") {
        // استدعاء الـ API — بعض الـ APIs قد تتوقع المعرف فقط أو كـ كائن، استخدم المعرف مباشرة
        await changeOrderItemStatusApi(itemId);
      } else {
        await updateItem({ id: itemId, status: "preparing" });
      }

      setSuccessMsg("✅ تم وضع الصنف قيد التجهيز");
      window.dispatchEvent(
        new CustomEvent("orderUpdated", {
          detail: { orderId, tableId: orderDetails.table_id },
        }),
      );
    } catch (err) {
      alert(err.message || "❌ فشل في تغيير حالة الصنف");
    }
  };

  // NEW: معالج طباعة التجهيز - يختار بين automatic و manuel حسب settings.printing_method
  // const handlePrintPreparation = async () => {
  //   if (!orderDetails) return alert("❌ لا توجد بيانات للطلب.");
  //   if (pendingItems.length === 0) return alert("❌ لا توجد أصناف قيد التجهيز للطباعة.");

  //   const printingMethod = (settings?.printing_method || "").toLowerCase();

  //   try {
  //     const ids = pendingItems.map((it) => it.id).filter(Boolean);

  //     if (printingMethod === "manuel" || printingMethod === "manual") {
  //       // استخدم طريقة الباك-إند للطباعة
  //       try {
  //         await printItems(ids); // printItems يتوقع مصفوفة المعرفات
  //         // بعد نجاح الطباعة عبر الباك-إند ضع الأصناف قيد التجهيز
  //         if (ids.length > 0) {
  //           await makeItemsInPreparation(ids);
  //         }
  //         setSuccessMsg("✅ تم إرسال الطباعة عبر الباك-إند وتم وضع الأصناف قيد التجهيز");
  //       } catch (errPrint) {
  //         console.error("❌ فشل في طباعة الباك-إند:", errPrint);
  //         alert(errPrint.message || "❌ فشل في طباعة العناصر (باك-إند)");
  //       }
  //     } else {
  //       // الافتراضي: automatic => استخدم طريقة الواجهة handleBrowserPrint
  //       try {
  //         await handleBrowserPrint({
  //           order: orderDetails,
  //           items: pendingItems,
  //         });
  //         // بعد نجاح الطباعة على المتصفح، ضع الأصناف قيد التجهيز عبر API
  //         if (ids.length > 0) {
  //           await makeItemsInPreparation(ids);
  //         }
  //         setSuccessMsg("✅ تم إرسال الطباعة وتم وضع الأصناف قيد التجهيز");
  //       } catch (errAuto) {
  //         console.error("❌ فشل في طباعة المتصفح:", errAuto);
  //         alert(errAuto.message || "❌ فشل في طباعة التجهيز");
  //       }
  //     }
  //   } catch (err) {
  //     console.error("❌ خطأ في معالج طباعة التجهيز:", err);
  //     alert(err.message || "❌ حدث خطأ أثناء طباعة التجهيز");
  //   }
  // };
const handlePrintPreparation = async () => {
  if (!orderDetails) return alert("❌ لا توجد بيانات للطلب.");
  if (pendingItems.length === 0) return alert("❌ لا توجد أصناف قيد التجهيز للطباعة.");

  const printingMethod = (settings?.printing_method || "").toLowerCase();

  try {
    const grouped = groupItemsByKitchen(pendingItems);
    const kitchenGroups = Object.values(grouped);

    const afterMark = async () => {
      try {
        await loadOrder(orderId, true);
      } catch (e) {
        console.warn("⚠️ فشل تحديث تفاصيل الأوردر بعد تغيير الحالة:", e);
      }
      window.dispatchEvent(
        new CustomEvent("orderUpdated", {
          detail: { orderId, tableId: orderDetails?.table_id },
        })
      );
    };

    // ✅ هنجمّع كل ids اللي اتطبعت (اختياري)
    const allPrintedIds = [];

    // ✅ اطبع مجموعة مجموعة (كل مطبخ لوحده)
    for (const group of kitchenGroups) {
      const itemsForKitchen = group.items;
      const idsForKitchen = itemsForKitchen.map((it) => it.id).filter(Boolean);

      // لو مفيش ids skip
      if (idsForKitchen.length === 0) continue;

      if (printingMethod === "manuel" || printingMethod === "manual") {
        // ✅ طباعة باك-إند لكل مطبخ لوحده
        await printItems(idsForKitchen);
      } else {
        // ✅ طباعة المتصفح لكل مطبخ لوحده
        // (اختياري) ابعت kitchen_name للتمبليت لو هتضيفه فوق
        await handleBrowserPrint({
          order: {
            ...orderDetails,
            _kitchen_name: group.kitchen_name,   // optional helper field
            _kitchen_id: group.kitchen_id,       // optional helper field
          },
          items: itemsForKitchen,
        });
      }

      allPrintedIds.push(...idsForKitchen);
    }

    // ✅ بعد ما نخلص كل المطابخ: نغيّر الحالة لكل اللي اتطبع
    const uniqueIds = Array.from(new Set(allPrintedIds));
    if (uniqueIds.length > 0) {
      await makeItemsInPreparation(uniqueIds);
      await afterMark();
    }

    setSuccessMsg("✅ تم طباعة الأصناف منفصلة لكل مطبخ وتم وضعها قيد التجهيز");
  } catch (err) {
    console.error("❌ خطأ في معالج طباعة التجهيز:", err);
    alert(err?.message || "❌ حدث خطأ أثناء طباعة التجهيز");
  }
};

    const groupItemsByKitchen = (items = []) => {
      return items.reduce((acc, item) => {
        const key = item?.kitchen_id ?? "no_kitchen";
        if (!acc[key]) acc[key] = { kitchen_id: key, kitchen_name: item?.kitchen_name || "بدون مطبخ", items: [] };
        acc[key].items.push(item);
        return acc;
      }, {});
    };

  // ✅ معالج حذف الأوردر بالكامل
  const handleDeleteOrder = async () => {
    if (!orderDetails) return alert("❌ لا توجد تفاصيل للطلب حالياً.");

    if (!window.confirm("❗ هل أنت متأكد من حذف الطلب بالكامل؟")) return;

    try {
      await deleteOrder(orderDetails.id);
      setSuccessMsg("✅ تم حذف الطلب بنجاح");

      // 🔔 إشعار للـ TablesSection
      window.dispatchEvent(
        new CustomEvent("orderUpdated", {
          detail: { orderId, tableId: orderDetails.table_id },
        }),
      );

      // استدعاء callback من parent
      if (onOrderDeleted) onOrderDeleted();
      if (onClose) onClose();
    } catch (err) {
      alert(err.message || "❌ فشل في حذف الطلب");
    }
  };

  if (loading) return <p className="text-gray-500">جاري تحميل التفاصيل...</p>;
  if (error) return <p className="text-red-500">❌ {error}</p>;
  if (!orderDetails) return null;

  const pendingItems =
    orderDetails?.items?.filter((item) => item.status === "pending") || [];

  return (
    <div className="bg-white p-4 rounded shadow-md mb-4">
      <div className="grid grid-cols-2 gap-4 text-sm">
        <OrderInfoCard
          details={orderDetails}
          onEdit={(data) => {
            setEditData({
              ...data,
              order_id: orderDetails.id,
              customer_id: orderDetails.customer?.id || "",
              customer_phone1: orderDetails.customer?.phone1 || "",
              customer_phone2: orderDetails.customer?.phone2 || "",
              customer_phone3: orderDetails.customer?.phone3 || "",
              customer_address1: orderDetails.customer?.address1 || "",
              customer_address2: orderDetails.customer?.address2 || "",
              customer_address3: orderDetails.customer?.address3 || "",
              delivery_name: orderDetails.delivery?.name || "",
            });
            setEditOpen(true);
          }}
          tables={tables}
          onDelete={handleDeleteOrder} // ✅ تمرير معالج حذف الأوردر الجديد
        />
      </div>

      {hasPermission("orders_tables_print_preparation_table") && (
        <div className="flex justify-end mb-4">
          <IconButton
            onClick={(e) => setKitchenMenuAnchor(e.currentTarget)}
            sx={{
              bgcolor: "#f48fb1",
              color: "#fff",
              borderRadius: "50%",
              mr: 2,
            }}
          >
            <KitchenIcon />
          </IconButton>
          <Button
            variant="contained"
            sx={{
              bgcolor: printingEnabled ? "#4caf50" : "#ccc",
              color: "#fff",
              borderRadius: 2,
              px: 3,
              fontWeight: 600,
              "&:hover": {
                bgcolor: printingEnabled ? "#45a049" : "#ccc",
              },
            }}
            disabled={!printingEnabled}
            onClick={handlePrintPreparation}
            title="طباعة تجهيز (F9)" // ✅ إضافة tooltip يوضح الاختصار
          >
            {printingEnabled ? "طباعة تجهيز" : "لا يوجد"}
          </Button>

          <Menu
            anchorEl={kitchenMenuAnchor}
            open={Boolean(kitchenMenuAnchor)}
            onClose={() => setKitchenMenuAnchor(null)}
          >
            {pendingItems.length > 0 ? (
              pendingItems.map((item) => (
                <MenuItem key={item.id}>
                  {item.product_name} - الكمية: {item.quantity}
                </MenuItem>
              ))
            ) : (
              <MenuItem>لا توجد أصناف قيد التجهيز</MenuItem>
            )}
          </Menu>
        </div>
      )}

      <OrderItemsList
        items={orderDetails.items.map((item) => {
          const s = (item.status || "pending").toLowerCase();

          const normalized = s === "in_preparation" ? "in_prepration" : s; // وحّدها على اللي بتستخدمه في UI

          return { ...item, status: normalized };
        })}
        onDeleteItem={handleDeleteItem}
        onEditItem={(item) => {
          setSelectedItem(item);
          setItemEditOpen(true);
        }}
        onMoveItem={(item) => {
          setSelectedMoveItem(item);
          setMoveModalOpen(true);
        }}
        tables={tables}
        // NEW props passed to OrderItemsList
        preparationCasherEnabled={preparationCasherEnabled}
        onPrepareItem={handlePrepareItem}
        changeOrderItemStatus={changeOrderItemStatus} // <-- pass the new function
      />

      <MoveItemModal
        open={moveModalOpen}
        onClose={() => setMoveModalOpen(false)}
        onSubmit={handleMoveItem}
        item={selectedMoveItem}
        tables={tables}
      />

      <EditOrderForm
        open={editOpen}
        onClose={(updatedData) => {
          setEditOpen(false);
          if (updatedData) {
            updateItem(updatedData);

            // 🔔 إشعار
            window.dispatchEvent(
              new CustomEvent("orderUpdated", {
                detail: { orderId, tableId: orderDetails.table_id },
              }),
            );
          }
        }}
        initialData={editData || {}}
      />

      <EditItemModal
        open={itemEditOpen}
        item={selectedItem}
        onClose={() => setItemEditOpen(false)} // 👈 اقفل المودال بس
      />

      <Snackbar
        open={!!successMsg}
        autoHideDuration={3000}
        onClose={() => setSuccessMsg("")}
      >
        <Alert severity="success">{successMsg}</Alert>
      </Snackbar>
    </div>
  );
};

export default OrderDetailsFetcher;
